"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleInventoryState = void 0;
const core_1 = require("@angular/core");
let VehicleInventoryState = class VehicleInventoryState {
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], VehicleInventoryState.prototype, "vehicle", void 0);
VehicleInventoryState = __decorate([
    (0, core_1.Component)({
        selector: 'vehicle-inventory-state',
        template: `
    <ng-container [ngSwitch]="vehicle.vehicleData.inventory?.state">
      <tag *ngSwitchCase="'ORDERED'" text="Vorlauf" color="blue">
        <svg class="ab-icon icon vmin-tablet-xl"><use xlink:href="#info-light"></use></svg>
        <div class="hover-content">
          <span *ngIf="vehicle.vehicleData.production?.productionState"><b>Produktionsstatus:</b> {{ vehicle.vehicleData.production?.productionState }} – {{ vehicle.vehicleData.production?.productionStateDescription }}</span> <br>
          <span *ngIf="vehicle.vehicleData.production?.confirmedProductionWeek"><b>Bestätigte Produktionswoche:</b> {{ vehicle.vehicleData.production.confirmedProductionWeek }}</span> <br>
        </div>
      </tag>

      <tag *ngSwitchCase="'STOCK'" text="Lager" color="green"></tag>

      <tag *ngSwitchCase="'SOLD'" text="Ausgeliefert" color="orange"></tag>
    </ng-container>
  `,
    })
], VehicleInventoryState);
exports.VehicleInventoryState = VehicleInventoryState;
